import React from 'react';
import PropTypes from 'prop-types';
import Input from '../Input';
import * as constants from '../../constants';

const TextField = ({
  field,
  intent,
  placeholder,
  disabled,
  autoComplete,
  autoCapitalize,
  inputType,
  onFocus,
  onBlur,
  fluid,
}: any) => {
  return (
    <div>
      <Input
        disabled={disabled}
        fluid={fluid}
        intent={intent}
        type={inputType}
        autoComplete={autoComplete}
        autoCapitalize={autoCapitalize}
        placeholder={placeholder}
        {...field}
        onFocus={onFocus}
        onBlur={(e?: any) => {
          onBlur(e);
          field.onBlur(e);
        }}
      />
    </div>
  );
};

(TextField as any).propTypes = {
  field: PropTypes.shape({}).isRequired,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  autoCapitalize: PropTypes.string,
  inputType: PropTypes.string,
  fluid: PropTypes.bool,
  disabled: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  intent: PropTypes.oneOf([
    constants.INFORMATION,
    constants.ERROR,
    constants.WARNING,
    constants.SUCCESS,
    constants.NEUTRAL,
  ]),
};

(TextField as any).defaultProps = {
  fluid: false,
  disabled: false,
  placeholder: '',
  autoComplete: 'on',
  autoCapitalize: 'on',
  inputType: 'text',
  onFocus: null,
  onBlur: (f?: any) => f,
  intent: constants.NEUTRAL,
};

export default TextField;
